var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,style:(_vm.styles),on:{"click":_vm.back}},[_vm._t("default",function(){return [_c('div',{class:_vm.innerClasses},[_c('img',{attrs:{"width":"40","src":"//htwuhan.oss-cn-beijing.aliyuncs.com/tool/backtopw.svg"}})])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }